import React, { useEffect, useState } from "react";
import Container from "../../components/Layout/Container";
import ContentBlock from "../../components/Layout/ContentBlock";
import FilterMenu from "../../components/Layout/FilterMenu";
import { ButtonDelete, ButtonEditRow } from "../../components/common/Buttons";
import TableFilterBox from "../../components/common/TableFilterBox";
import ContentValidation from "../../components/common/ContentValidation";
import {
  SelectInput,
  TextInput,
  ButtonSecondary,
} from "../../components/globals";
import TableUi from "../../components/Layout/TableUI";
import { handleKeyDown2 } from "../../helpers/FunctionsGlobal";
import { useFetch } from "../../hooks";
import { QueryClient, QueryClientProvider, useMutation } from "react-query";
import Axios from "axios";
import { antdMessageError, antdMessageSuccess, formatDatePlus, getDateFormat } from "../../helpers/Utils";
import RangePickerComp from "../../components/common/RangePickerComp";
import { IconSearch, IconTechnoramaDocuments } from "../../components/Layout/Icons";
import dayjs from "dayjs";
import DocumentsTabUi from "./components/DocumentsTabUi";
import PaginationComp from "../../components/Dashboard/items/Pagination";

const queryClient = new QueryClient();

function TechnoramaDocumentsPage({ match, history }) {
  return (
    <QueryClientProvider client={queryClient}>
      <TechnoramaDocumentsScreen match={match} history={history} />
    </QueryClientProvider>
  );
}
export default TechnoramaDocumentsPage;

function TechnoramaDocumentsScreen({ match, history }) {
  const [tabId, setTabId] = useState("all");
  const [page, setPage] = useState(1);
  const [perPage, setPerPage] = useState(100);
  const [filters, setFilters] = useState({
    created_at: ["", ""],
    status_eq: "",
    inner_document_number_cont: "",
    invoice_number_cont: "",
    department_code_eq: "",
    user_id_eq: "",
  });

  const buildQueryString = () => {
    const params = new URLSearchParams();
    params.append('page', page.toString());
    params.append('per_page', perPage.toString());

    if (tabId === 'new') {
      params.append('q[status_eq]', 'new');
    } else if (tabId === 'with_internal') {
      params.append('q[inner_document_number_not_null]', 'true');
    }

    Object.entries(filters).forEach(([key, value]) => {
      if (key === 'created_at') {
        const [startDate, endDate] = value;
        if (startDate) params.append('q[created_at_gteq]', startDate);
        if (endDate) params.append('q[created_at_lteq]', formatDatePlus(endDate));
      } else if (value && value.toString().trim()) {
        if (key === 'status_eq' && (tabId === 'new' || tabId === 'with_internal')) {
          return;
        }
        params.append(`q[${key}]`, value);
      }
    });

    return params.toString();
  };

  const apiUrl = `/api/v1/tr_inner_documents?${buildQueryString()}`;
  console.log('API URL:', apiUrl);

  const {
    value: valueDocuments,
    loading: loadingDocuments,
    setReFetch: setReFetchDocuments,
    setValue: setValueDocuments,
  } = useFetch(apiUrl, {}, [tabId, page, perPage, filters]);

  const {
    value: valueUsers,
    loading: loadingUsers,
  } = useFetch(`/api/v1/users`);

  const {
    value: valueStores,
  } = useFetch("/api/v1/also_incomes/vv_stores");

  const clearFilter = () => {
    setFilters({
      created_at: ["", ""],
      status_eq: "",
      inner_document_number_cont: "",
      invoice_number_cont: "",
      department_code_eq: "",
      user_id_eq: "",
    });
    setPage(1);
  };

  const onFilter = () => {
    setPage(1);
  };

  // vv_stores keys look like "vv_U021" and labels like "U021 - Aitvaras 2A salė"
  const getDepartmentOptions = () => {
    const stores = valueStores?.stores?.["verslo vartai"] || {};

    return [
      { value: "", label: "All", code: "" },
      ...Object.entries(stores).map(([key, label]) => {
        const code = key.replace(/^vv_/i, "");
        return {
          value: code,
          label: String(label).split(" - ").slice(1).join(" - ") || String(label),
          code,
        };
      }),
    ];
  };

  const filterDepartmentOption = (input, option) => {
    const search = String(input || "").replace(/^vv_/i, "").toLowerCase();
    if (!search) return true;
    const code = String(option?.value || "").toLowerCase();
    const label = String(option?.children || "").toLowerCase();
    return code.includes(search) || label.includes(search);
  };

  const getFilteredData = () => {
    return valueDocuments?.data || [];
  };

  return (
    <Container
      location={{
        locationName: "Technorama Documents",
        locationUrl: match?.url || "/technorama/documents",
      }}
    >
      <ContentBlock>
        <FilterMenu
          totals={valueDocuments?.total || 0}
          length={getFilteredData().length}
          iconComponent={<IconTechnoramaDocuments />}
          text2="Documents"
          onChangeCountPage={setPerPage}
          countPage={perPage}
          page={page}
        />
      </ContentBlock>

      <div className="col-12">
        <DocumentsTabUi tabId={tabId} setTabId={setTabId} />
      </div>

      <ContentBlock containerClass={"py-1"}>
        <TableFilterBox
          filter={true}
          onFilter={() => onFilter()}
          clearFilter={() => clearFilter()}
          button1={null}
        >
          <div className="px-1 d-flex flex-wrap">
            <div className="px-1">
              <RangePickerComp
                label="Date period"
                style={{ width: 250 }}
                value={
                  filters.created_at
                    ? [
                      getDateFormat(filters.created_at[0]),
                      getDateFormat(filters.created_at[1]),
                    ]
                    : []
                }
                onChange={(_, args) => {
                  setFilters((prev) => ({
                    ...prev,
                    created_at: args,
                  }));
                }}
              />
            </div>
            <div className="px-1">
              <SelectInput
                label="Status"
                style={{ width: 165 }}
                options={[
                  { value: "", label: "All" },
                  { value: "new", label: "New" },
                  { value: "completed", label: "Completed" },
                  { value: "canceled", label: "Canceled" },
                  { value: "failed", label: "Failed" },
                ]}
                value={filters.status_eq || undefined}
                onChange={(value) => {
                  setFilters((prev) => ({
                    ...prev,
                    status_eq: value,
                  }));
                }}
              />
            </div>
            <div className="px-1">
              <TextInput
                text="Internal doc. no."
                style={{ width: 165 }}
                value={filters.inner_document_number_cont || ""}
                onKeyDown={handleKeyDown2(onFilter)}
                onChange={(val) => {
                  setFilters((prev) => ({
                    ...prev,
                    inner_document_number_cont: val.target.value,
                  }));
                }}
              />
            </div>
            <div className="px-1">
              <TextInput
                text="Invoice no."
                style={{ width: 165 }}
                value={filters.invoice_number_cont || ""}
                onKeyDown={handleKeyDown2(onFilter)}
                onChange={(val) => {
                  setFilters((prev) => ({
                    ...prev,
                    invoice_number_cont: val.target.value,
                  }));
                }}
              />
            </div>
            <div className="px-1">
              <SelectInput
                label="Department"
                style={{ width: 165 }}
                options={getDepartmentOptions()}
                filterOption={filterDepartmentOption}
                value={filters.department_code_eq || undefined}
                onChange={(value) => {
                  setFilters((prev) => ({
                    ...prev,
                    department_code_eq: value,
                  }));
                }}
              />
            </div>
            <div className="px-1">
              <SelectInput
                label="Manager"
                style={{ width: 165 }}
                options={[
                  { value: "", label: "All" },
                  ...(valueUsers?.data?.map((user) => ({
                    value: user.id,
                    label: `${user.firstname || ''} ${user.lastname || ''}`.trim() || user.email,
                  })) || [])
                ]}
                value={filters.user_id_eq || undefined}
                onChange={(value) => {
                  setFilters((prev) => ({
                    ...prev,
                    user_id_eq: value,
                  }));
                }}
              />
            </div>
          </div>
        </TableFilterBox>
        <div>
          <ContentValidation loader={loadingDocuments} array={getFilteredData()}>
            <div className="table-responsive">
              <PaginationComp
                className="mb-3"
                setPagination={setPage}
                page={page}
                totals={valueDocuments?.total || 0}
                pageCount={perPage}
                onChangeCountPage={setPerPage}
              />

              <TableUi
                ths={["Request no.", "Creation date", "Status", "Supplier code", "Internal doc. no.", "Invoice no.", "Department", "Sup. order No.", "Manager", "Total/Used QTY", ""]}
                total={getFilteredData().length}
              >
                {getFilteredData().map((data, index) => (
                  <TableUi.tr key={index}>
                    <TableUi.td>
                      <div style={{ paddingLeft: 15 }}>
                        <p className="document-title">{data?.tr_request_id || '-'}</p>
                      </div>
                    </TableUi.td>
                    <TableUi.td>
                      <div style={{ paddingTop: 15, marginBottom: 15 }}>
                        <p>{data?.created_at ? dayjs(data.created_at).format('YYYY-MM-DD') : '-'}</p>
                      </div>
                    </TableUi.td>
                    <TableUi.td>
                      <div style={{ paddingTop: 15, marginBottom: 15 }}>
                        <p>{data?.status || 'new'}</p>
                      </div>
                    </TableUi.td>
                    <TableUi.td>
                      <div style={{ paddingTop: 15, marginBottom: 15 }}>
                        <p>{data?.supplier_id || '-'}</p>
                      </div>
                    </TableUi.td>
                    <TableUi.td>
                      <div style={{ paddingTop: 15, marginBottom: 15 }}>
                        <p>{data?.inner_document_number || '-'}</p>
                      </div>
                    </TableUi.td>
                    <TableUi.td>
                      <div style={{ paddingTop: 15, marginBottom: 15 }}>
                        <p>{data?.invoice_number || '-'}</p>
                      </div>
                    </TableUi.td>
                    <TableUi.td>
                      <div style={{ paddingTop: 15, marginBottom: 15 }}>
                        <p>{data?.department_code} - {data?.department_name}</p>
                      </div>
                    </TableUi.td>
                    <TableUi.td>
                      <div style={{ paddingTop: 15, marginBottom: 15 }}>
                        <p>{data?.supplier_order_number || '-'}</p>
                      </div>
                    </TableUi.td>
                    <TableUi.td>
                      <div style={{ paddingTop: 15, marginBottom: 15 }}>
                        <p>{
                          valueUsers?.data?.find(user => user.id === data?.user_id)?.firstname &&
                            valueUsers?.data?.find(user => user.id === data?.user_id)?.lastname
                            ? `${valueUsers?.data?.find(user => user.id === data?.user_id)?.firstname} ${valueUsers?.data?.find(user => user.id === data?.user_id)?.lastname}`
                            : valueUsers?.data?.find(user => user.id === data?.user_id)?.email || '-'
                        }</p>
                      </div>
                    </TableUi.td>
                    <TableUi.td>
                      <div style={{ paddingTop: 15, marginBottom: 15 }}>
                        <p>{data?.total_qty ? `${data.total_qty}/${data.used_qty || 0}` : '-'}</p>
                      </div>
                    </TableUi.td>
                    <TableUi.td>
                      <div
                        className="d-flex flex-row gap-1 justify-content-end"
                        style={{ marginRight: 15 }}
                      >
                        <button
                          className="btn btn-sm btn-primary"
                          onClick={() =>
                            history.push(`/technorama/documentDetails?id=${data.id}`)
                          }
                        >
                          <IconSearch color="#fff" />
                        </button>
                      </div>
                    </TableUi.td>
                  </TableUi.tr>
                ))}
              </TableUi>

              <PaginationComp
                className="mb-0"
                setPagination={setPage}
                page={page}
                totals={valueDocuments?.total || 0}
                pageCount={perPage}
                onChangeCountPage={setPerPage}
              />
            </div>
          </ContentValidation>
        </div>
      </ContentBlock>

    </Container>
  );
}

